import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import _ from "underscore";
import { getWindow } from "ssr-window";
import { Placeholder } from "@sitecore-jss/sitecore-jss-react";
import { withTranslation } from "react-i18next";
import RelatedArticle from "@/react-components/RelatedArticle";
import Pagination from "@/react-components/Pagination";
import CoverImage from "@/react-components/CoverImage";
import Evaluate from "@/react-components/Evaluate";
import { modeEnum } from "@/utils/enum";
import { openLink, scrollTop } from "@/utils";

class MainDetail extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      pageNumber: 0, // 改ページ記号
      pageSize: 0, // ページ数
      componentList: [], // component list
      toolbar: undefined, // toolbar
    };
  }

  componentDidMount() {
    this.getComponentList();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps?.props?.context?.itemId !== this.props?.props?.context?.itemId
    ) {
      scrollTop();
      this.getComponentList();
    }
  }

  // get component list
  getComponentList = () => {
    const { mode } = this.props;
    if (mode !== modeEnum.pageEditing) {
      this.getOtherComponentList();
    }
  };

  openReportPdf = () => {
    const { t } = this.props;
    const link = t("TCMS01011_publicationInforLink");
    const title = t("TCMS01011_publicationInforText");
    openLink(link, "", "pdf", title, undefined, undefined, "1");
  };

  getEditingComponentList = () => {
    const {
      children,
      props: {
        rendering: { fields },
      },
    } = this.props;
    const componentList = [...children];
    if (children.length > 0) {
      let position;
      for (let index = 0; index < componentList.length; index++) {
        const item = componentList[index];
        const componentName = item.props?.rendering?.componentName;
        if (componentName === "HeaderSection") {
          position = index;
          break;
        }
      }
      if (position !== undefined && fields?.coverIsShow?.value) {
        componentList.splice(
          position + 1,
          0,
          <CoverImage
            image={fields?.cover?.value}
            title={fields?.coverTitle?.value}
            desc={fields?.coverDesc?.value}
          />
        );
      }
    }
    this.addCommonFooter(componentList);
    return componentList;
  };

  getOtherComponentList = () => {
    const {
      children,
      props: {
        rendering: { fields },
      },
    } = this.props;
    if (children.length > 0) {
      const pageSize =
        children.filter(
          (item) => item.props?.rendering?.componentName === "SplitPageSection"
        ).length + 1;
      const componentList = [];
      let toolbar;
      let addCover = false;
      let tempList = [];
      children.forEach((item, index) => {
        const componentName = item.props?.rendering?.componentName;
        if (componentName === "ToolbarSection" && !toolbar) {
          toolbar = item;
        } else if (componentName !== "SplitPageSection") {
          tempList.push(item);
        }
        if (
          componentName === "HeaderSection" &&
          !addCover &&
          fields?.cover?.value?.src &&
          fields?.coverIsShow?.value
        ) {
          tempList.push(
            <CoverImage
              key={index}
              image={fields?.cover?.value}
              title={fields?.coverTitle?.value}
              desc={fields?.coverDesc?.value}
            />
          );
        }
        if (
          index === children.length - 1 ||
          componentName === "SplitPageSection"
        ) {
          componentList.push(tempList);
          tempList = [];
        }
      });
      if (componentList.length > 0) {
        this.addCommonFooter(componentList[componentList.length - 1]);
      }
      this.setState({
        pageSize,
        componentList,
        toolbar,
        pageNumber: getWindow()?.history?.state?.page || 0,
      });
    }
  };

  addCommonFooter = (componentList) => {
    if (!componentList) {
      return;
    }
    const {
      props: {
        rendering: { placeholders },
        routeData,
      },
      showCommonFooter,
    } = this.props;
    if (placeholders["jss-common-footer"]?.length > 0 && showCommonFooter) {
      componentList.push(
        <React.Fragment key="jss-common-footer">
          <div className="content-main-detail-report-common-footer" />
          <div id="publication-infor-link">
            <span style={{ cursor: "pointer" }} onClick={this.openReportPdf}>
              {this.props.t("TCMS01011_publicationInforText")}
            </span>
          </div>
          <div id="publication-infor-pdf" style={{ display: "none" }}>
            <Placeholder
              name="jss-common-footer"
              rendering={routeData}
              routeData={routeData}
            />
          </div>
        </React.Fragment>
      );
    }
  };

  render() {
    const {
      children,
      mode,
      configRouter,
      showRelated,
      showEvaluate,
    } = this.props;
    const { pageNumber, pageSize, componentList, toolbar } = this.state;
    if (mode === modeEnum.pageEditing) {
      return <React.Fragment>{this.getEditingComponentList()}</React.Fragment>;
    }
    return (
      <React.Fragment>
        {toolbar}
        <div className="content-main-detail-report">
          <div id="content-main-detail">{componentList[pageNumber]}</div>
          <div className="pagination-container main-detail-pagination-container">
            {children.length > 0 && pageSize > 1 && (
              <Pagination
                totalPage={pageSize}
                pageIndex={pageNumber + 1}
                onChange={(page) => {
                  const state = getWindow()?.history?.state || {};
                  state.page = page - 1;
                  getWindow().history.replaceState(state, "");
                  this.setState({ pageNumber: page - 1 }, () => {
                    scrollTop();
                  });
                }}
              />
            )}
          </div>
        </div>
        {showEvaluate ? (
          <React.Fragment>
            <div className="content-main-detail-gray-line" />
            <Evaluate {...this.props.props} />
          </React.Fragment>
        ) : null}
        {showRelated ? (
          <React.Fragment>
            <div className="content-main-detail-gray-line" />
            <RelatedArticle
              {...this.props.props}
              reportType={configRouter?.reportType}
            />
          </React.Fragment>
        ) : null}
        {componentList && componentList.length > 0 && toolbar && (
          <div id="content-main-all-detail">
            {_.reduce(componentList, (list1, list2) => list1.concat(list2))}
          </div>
        )}
      </React.Fragment>
    );
  }
}

MainDetail.propTypes = {
  data: PropTypes.array.isRequired,
  props: PropTypes.object.isRequired,
  showRelated: PropTypes.bool,
  showEvaluate: PropTypes.bool,
  showCommonFooter: PropTypes.bool,
};

MainDetail.defaultProps = {
  showRelated: true,
  showEvaluate: true,
  showCommonFooter: false,
};

const mapStateToProps = (state) => {
  return {
    mode: state?.config?.mode,
    configRouter: state?.config?.configRouter,
  };
};

export default connect(mapStateToProps)(withTranslation()(MainDetail));
